import React, { useState, useMemo } from 'react'
import { Form, Button, Icon, Header } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { useSubscription } from 'utils'

export default function ConsultarSefazForm({ empresas, formSefaz, setFormSefaz, setSituacaoCupom, setShowModal }) {
    
    const [isSubmitting, setIsSubmitting] = useState(false)

    function handleChange(_, { name, value }) {
        setFormSefaz({ payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!formSefaz.empresa) || !(!!formSefaz.cupom))
            toast.error('Há campos vazios!')
        else 
            setIsSubmitting(true)
    }

    const submitForm$ = useMemo(() => request({ 
        url: '/nfce/consultar-sefaz', 
        method: 'POST', 
        body: formSefaz
    }).pipe(
        tap(({ response }) => {
            setSituacaoCupom(response.situacao)
            setShowModal(true)
        }),
        finalize(() => setIsSubmitting(false))
    ), [formSefaz, setSituacaoCupom, setShowModal])

    useSubscription(submitForm$, isSubmitting)

    return (
        <div className="col d-flex flex-column flex-grow-1">
            <Header as='h3'>
                <Icon.Group size='big'>
                    <Icon name='search' className='primary-color' />
                </Icon.Group>
                <Header.Content className='primary-color'>
                    Consultar cupom na sefaz
                    <Header.Subheader className='secondary-color'>
                        <strong>Buscar situação do cupom NFC-e</strong>
                    </Header.Subheader>
                </Header.Content>
            </Header>
            <div className='d-flex flex-column flex-grow-1 align-items-center justify-content-center'>

                <Form size='mini' className='w-100' loading={isSubmitting} onSubmit={handleSubmit} noValidate>
                    <div className="row">
                        <div className="col col-md-8 offset-md-2">
                            <Form.Select search noResultsMessage='Nenhum resultado encontrado' required label='Empresa' placeholder='Selecionar empresa' name='empresa' value={formSefaz.empresa} onChange={handleChange} options={empresas ? empresas.filter(x => x.ativo === 1 && x.tipo === 'POSTO').map(x => Object.assign({}, { text: x.codDpnet + ' - ' + x.nomeEmpresa, value: x._id })) : []} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col col-md-8 offset-md-2">
                            <Form.Input type='number' required label='Cupom' placeholder='Informe o cupom à consultar' name='cupom' value={formSefaz.cupom} onChange={handleChange} autoComplete="off" />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col text-center">
                            <Button size='mini' color='green'><Icon name='send' /> Consultar</Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}
